import React, { useState } from "react";
import Parse from "../../api/ApiConfig";
import { SelectField, TextAreaField } from "../Form/FormComponents";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { setLoadingState } from "../../redux/AppSlice";
import { useParams } from "react-router-dom";
import { RequestStatusFormWrapper } from "./RequestStatusForm.styled";
import { handleAdminUpdateLease, onAdminUpdatesRequestStatus } from "../../screens/lease/utils";

/* eslint-disable react/prop-types */
//chnage all if conditions to switch cases
//read this code properly
const RequestStatusForm = ({ formData, handleInputChange, adminComments, onBeginFundRequest }) => {
	const { adminQuickRequests } = useSelector((state) => state.lease);

	const [approvalState, setApprovalState] = useState("");
	const currentUser = Parse.User.current();
	const privileges = currentUser.get("privileges");
	const role = currentUser.get("role");

	let { id: objectId } = useParams();
	const dispatch = useDispatch();

	const handleApprovalState = (e) => {
		setApprovalState(e.target.value);
	};

	const userCheck = () => {
		if (privileges === "admin" && role === "Risk & Compliance") {
			return privileges;
		}
		if (privileges === "firstLineApproval" && role === "Risk & Compliance") {
			return privileges;
		}
		if (privileges === "secondLineApproval" && role === "Risk & Compliance") {
			return privileges;
		}
		if (privileges === "finalApproval" && role === "Risk & Compliance") {
			return privileges;
		}
		if (privileges === "admin" && role === "Finance") {
			return privileges + "Finance";
		}
		if (privileges === "firstLineApproval" && role === "Finance") {
			return privileges + "Finance";
		} else {
			return "all";
		}
	};

	// check if any admins rejects request
	const isRejectRequest = adminComments
		?.filter((c) => !c.status?.includes("Recommend"))
		?.find((a) => a?.status?.includes("Reject"));

	//check if the rquest has been approved for each user
	const approvalStatusCheck = () => {
		if (isRejectRequest) {
			return true;
		}
		if (userCheck() === "admin" && formData?.basicAdminApproval?.status) {
			return true;
		}
		if (userCheck() === "firstLineApproval" && formData?.firstLineApproval?.status) {
			return true;
		}
		if (userCheck() === "secondLineApproval" && formData?.secondLineApproval?.status) {
			return true;
		}
		if (userCheck() === "finalApproval" && formData?.finalApproval?.status) {
			return true;
		}
		//first admin guy
		if (userCheck() === "adminFinance" && formData?.financeApproval?.status) {
			return true;
		}

		//final guy,
		if (userCheck() === "firstLineApprovalFinance" && formData?.approvalStatus !== "pending") {
			return true;
		}

		if (formData?.approvalStatus === "rejected") {
			return true;
		}

		// if (formData?.approvalStatus === "approved" || formData?.approvalStatus === "approved") {
		// 	return true;
		// }
		if (userCheck === "all") {
			return false;
		} else {
			return false;
		}
	};

	// console.log(formData);

	const updateStatus = async () => {
		if (!formData?.requestComment || !approvalState) {
			toast.error("Please  add a comment and select an action!");
			return;
		}
		if (userCheck() === "firstLineApproval" && !formData?.basicAdminApproval?.status) {
			toast.error("Lease Request has not been recommended for approval by admin");
			return;
		}
		if (userCheck() === "secondLineApproval" && !formData?.firstLineApproval?.status) {
			toast.error("Lease Request has not been recommended for approval by first line admin");
			return;
		}
		if (userCheck() === "finalApproval" && !formData?.secondLineApproval?.status) {
			toast.error("Lease Request has not been recommended for approval by second line  admin");
			return;
		}
		if (userCheck() === "adminFinance" && !formData?.finalApproval?.status) {
			toast.error("Lease Request has not been recommended for approval by the Risk & Compliance department");
			return;
		}
		if (userCheck() === "firstLineApprovalFinance" && !formData?.financeApproval?.status) {
			toast.error("Lease Request has not been recommended for approval by the basic finance admin");
			return;
		}
		if (userCheck() === "all") {
			toast.error("You are not authorized to approve this request, please contact the finance department");
			return;
		}
		// const data = {
		// 	id: objectId,
		// 	state: approvalState,
		// 	comment: formData?.requestComment,
		// };

		const objKey =
			userCheck() === "admin"
				? "basicAdminApproval"
				: userCheck() === "adminFinance"
				? "financeApproval"
				: userCheck();

		const newData = {
			[objKey]: { status: approvalState, comment: formData?.requestComment },
			approvalStatus: approvalState?.includes("Reject") ? "rejected" : formData?.approvalStatus,
		};

		const financeFirstLineAdminData = {
			approvalStatus: approvalState?.includes("Reject") ? "rejected" : "approved",
		};

		const updatedInvestorArr = formData?.assetObj?.investorsArray?.map((a) => {
			if (a?.user === "Fortcore Admin") {
				return { ...a, approvalStatus: approvalState?.includes("Reject") ? "rejected" : "approved" };
			} else {
				return a;
			}
		});

		// console.log(updatedInvestorArr);

		const firstLineAdminAppOrRejectOneRequest = () => {
			let allUpdatedRequests = [];
			if (approvalState === "Approve") {
				allUpdatedRequests = adminQuickRequests?.map((a) => {
					if (a?.objectId === formData?.objectId) {
						return { id: formData?.objectId, ...newData };
					} else {
						return {
							id: a?.objectId,
							approvalStatus: "rejected",
							firstLineApproval: {
								status: "Reject",
								comment: "This request has been rejected because another has been approved",
							},
						};
					}
				});
				return allUpdatedRequests;
			} else if (approvalState === "Reject") {
				return [{ id: objectId, ...newData }];
			}
		};

		const finalLineAdminApproveRequest = [
			{
				id: objectId,
				finaLineAdmin: { status: approvalState, comment: formData?.requestComment },
				approvalStatus: approvalState?.includes("Reject") ? "rejected" : "approved",
				investorsArray: updatedInvestorArr,
			},
		];

		const dataToUpdate =
			formData?.leaseSource === "market-place" && userCheck() === "firstLineApproval"
				? firstLineAdminAppOrRejectOneRequest()
				: formData?.leaseSource === "market-place" && userCheck() === "finalApproval"
				? finalLineAdminApproveRequest
				: userCheck() === "firstLineApprovalFinance"
				? financeFirstLineAdminData
				: newData;

		console.log(dataToUpdate, userCheck(), approvalState, objectId, dispatch, formData?.leaseSource);

		try {
			dispatch(setLoadingState(true));

			let response;

			if (formData?.leaseSource === "market-place" && formData?.leaseType === "Quick Lease") {
				console.log("yes");
				response = await onAdminUpdatesRequestStatus(
					formData?.assetObj?.id,
					{ investorsArray: updatedInvestorArr },
					dataToUpdate
				);
			} else {
				console.log("no");
				response = await handleAdminUpdateLease(objectId, dataToUpdate);
			}

			console.log(response);
			if (response) {
				toast.success("Request status updated successfully!");

				setTimeout(() => {
					location.reload();
				}, 700);

				setTimeout(() => {
					dispatch(setLoadingState(false));
				}, 1000);
			}
			dispatch(setLoadingState(false));
		} catch (error) {
			toast.error(error);
			dispatch(setLoadingState(false));
		}

		//super admin
		// dispatch(setLoadingState(true));
		// const response = updateRequestStatus(data, service);
		// response.then((res) => {
		// 	if (!res?.error) {
		// 		console.log(data);
		// 		console.log("res", res);
		// 		toast.success("Request status updated successfully!");
		// 		location.reload();
		// 		dispatch(setLoadingState(false));
		// 	} else {
		// 		toast.error(res?.error || "Error updating request status!");
		// 		dispatch(setLoadingState(false));
		// 	}
		// });
	};

	const setApprovalMessage = () => {
		// if any admin rejects request
		if (isRejectRequest) {
			return (
				<p style={{ fontWeight: "600" }}>
					{isRejectRequest?.admin} has rejected this request. Check approval status for comment.
				</p>
			);
		}
		//need the funded column
		if (formData?.approvalStatus === "rejected" || formData?.approvalStatus === "reject") {
			return <p>Lease Request has been rejected</p>;
		} else if (formData?.approvalStatus === "approved" && !formData?.funded) {
			return (
				<>
					<p style={{ fontWeight: "600", marginTop: "1.5rem" }}>
						Lease Request has been approved and is awaiting funding from the finance department (First Line
						Admin).
					</p>
					{userCheck() === "firstLineApprovalFinance" && (
						<Button variant='contained' sx={{ width: "auto" }} onClick={onBeginFundRequest}>
							Fund Request
						</Button>
					)}
				</>
			);
		} else if (formData?.approvalStatus === "pending" && formData?.funded) {
			return (
				<p style={{ fontWeight: "600", marginTop: "1.5rem" }}>
					Asset has already been funded. Approval required.
				</p>
			);
		} else if (formData?.funded) {
			return (
				<p style={{ fontWeight: "600", marginTop: "1.5rem" }}>Lease Request has been approved and funded</p>
			);
		} else {
			return null;
		}
	};

	return (
		<RequestStatusFormWrapper>
			<div className='statusFlow mt-4'>
				<div className={"statusFlow_item " + (formData?.firstPayment ? "done" : "")}>
					{formData?.firstPayment ? "First Payment Made" : "Awaiting First Payment"}
				</div>
				<div className={"statusFlow_item " + (formData?.leaseAgreement ? "done" : "")}>
					{formData?.leaseAgreement ? "Lease Agreement Signed" : "Awaiting Lease Agreement"}
				</div>
				{formData?.leaseSource === "products-catalogue" ? (
					<div className={"statusFlow_item " + (formData?.funded ? "done" : "")}>
						{formData?.funded ? "Lease Request has been Funded" : "Awaiting Request Funding"}
					</div>
				) : (
					<div className='statusFlow_item done'>Asset has been funded</div>
				)}
				{formData?.leaseSource === "products-catalogue" && (
					<div className={"statusFlow_item " + (formData?.approvalStatus === "approved" ? "done" : "")}>
						{formData?.approvalStatus === "pending"
							? "Awaiting First Line Approval (Finance)"
							: formData?.approvalStatus === "rejected"
							? "Lease Request has been Rejected"
							: "Lease Request has been approved for Funding"}
					</div>
				)}
				{formData?.leaseSource === "products-catalogue" && (
					<div className={"statusFlow_item " + (formData?.financeApproval?.status ? "done" : "")}>
						Awaiting Admin Approval(Finance)
					</div>
				)}
				<div className={"statusFlow_item " + (formData?.finalApproval?.status ? "done" : "")}>
					Awaiting Final Line Approval(Risk & Compliance)
				</div>
				<div className={"statusFlow_item " + (formData?.secondLineApproval?.status ? "done" : "")}>
					Awaiting second line approval (Risk & Compliance)
				</div>
				<div className={"statusFlow_item " + (formData?.firstLineApproval?.status ? "done" : "")}>
					Awaiting first line approval (Risk & Compliance)
				</div>
				<div className={"statusFlow_item " + (formData?.basicAdminApproval?.status ? "done" : "")}>
					Awaiting Risk & Compliance Admin Recommendation
				</div>
				{formData?.leaseSource === "market-place" && (
					<div className={"statusFlow_item " + (formData?.funded ? "done" : "")}>
						{formData?.funded ? "Lease Request has been Funded" : "Awaiting Request Funding"}
					</div>
				)}
				<div className='statusFlow_item done'>Request Submitted</div>
				<div className='statusFlow_item done'>Credit Assessment</div>
				<div className='statusFlow_item done'>Awaiting Guarantor</div>
				<div className='statusFlow_item done'>Auto Debit</div>
			</div>

			<div className='w-1-2'>
				<div className='form-group'>
					{/* <SelectField
						name='requestStatus'
						handleChange={handleInputChange}
						isEditable={true}
						value={formData?.requestStatus}
						placeholder={isAwaitingFinance ? "-- Action --" : "-- Recommend: Approve or reject"}
						options={isAwaitingFinance ? ["Finance"] : ["Approve", "Reject"]}
					/> */}
					{setApprovalMessage()}

					<SelectField
						name=''
						handleChange={handleApprovalState}
						isEditable={!approvalStatusCheck()}
						value={approvalState}
						placeholder={"-- Action --"}
						options={
							userCheck() === "admin" || userCheck() === "adminFinance"
								? ["Recommend for Approval", "Recommend for Rejection"]
								: userCheck() === "firstLineApprovalFinance"
								? ["Approve for Financing", "Reject for Financing"]
								: ["Approve", "Reject"]
						}
					/>
				</div>

				<div className='form-group'>
					<TextAreaField
						name='requestComment'
						handleChange={handleInputChange}
						isEditable={!approvalStatusCheck()}
						value={formData?.requestComment}
						placeholder={"Write a comment"}
					/>
				</div>

				<Button
					disabled={approvalStatusCheck()}
					variant='contained'
					color='primary'
					onClick={updateStatus}
					sx={{ mt: 2.5, px: 5 }}>
					Submit
				</Button>
				{/* //check if admins has approved */}

				{/* // remianing finance approval and super admin */}
			</div>
		</RequestStatusFormWrapper>
	);
};

// Update request status API call
export const updateRequestStatus = async (data, service) => {
	try {
		if (data) {
			let url = process.env.REACT_APP_SERVER_URL;
			if (service === "lease") {
				url += "/functions/leaseReview";
			} else if (service === "apprenticeship") {
				url += "/functions/AFReview";
			} else if (service === "travel-advance") {
				url += "/functions/TAReview";
			} else {
				return { error: "Invalid service" };
			}

			// Fetch data from server
			const response = await fetch(url, {
				method: "POST",
				body: JSON.stringify(data),
				headers: {
					"X-Parse-Application-Id": "FortCore",
					"X-Parse-Session-Token": Parse.User.current().getSessionToken(),
				},
			});
			const res = await response.json();
			console.log(data, res);
			return !res.error ? res : { error: res.error };
		} else {
			return { error: "Request Data not specified" };
		}
	} catch (error) {
		console.log("errorCatch", error);
		return null;
	}
};

export default RequestStatusForm;
